"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorPremiumWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_services_1 = require("@ferry/journey-services");
var core_1 = require("@athena-portal/core");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualMotorMtaPremiumWordingGenerator_1 = require("../../../helpers/annual/motor/AnnualMotorMtaPremiumWordingGenerator");
var RenewalDeclineOnMtaBanner_1 = require("../../../components/banners/RenewalDeclineOnMtaBanner");
var AnnualMotorPremiumWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorPremiumWidget, _super);
    function AnnualMotorPremiumWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.getRenewalPremiumWording = function () {
            var hasPendingRenewal = _this.props.interaction.uistate.renewalWindow;
            var previousRenewalPrice = hasPendingRenewal ? _this.props.interaction.uistate.totalOriginalRenewalAmount : 0;
            var currentRenewalPrice = _this.props.interaction.uistate.totalRenewalAmount;
            if (!hasPendingRenewal) {
                return null;
            }
            if (previousRenewalPrice === currentRenewalPrice) {
                return ((0, jsx_runtime_1.jsxs)("div", { className: "font-weight-semi-bold mb-0", children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Your renewal price has also stayed the same at ", (0, commonFunctions_1.getAmountWithDecimalDigits)(currentRenewalPrice)] }), (0, jsx_runtime_1.jsx)("p", { children: "Please check your renewal tile for further details" })] }));
            }
            else {
                return ((0, jsx_runtime_1.jsxs)("div", { className: "font-weight-semi-bold mb-0", children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Your renewal price has changed from ", (0, commonFunctions_1.getAmountWithDecimalDigits)(previousRenewalPrice), " to ", (0, commonFunctions_1.getAmountWithDecimalDigits)(currentRenewalPrice), "."] }), (0, jsx_runtime_1.jsx)("p", { children: "Please check your renewal tile for further details" })] }));
            }
        };
        _this.state = {
            previousPolicyInteraction: null,
        };
        return _this;
    }
    AnnualMotorPremiumWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.propositionEngine.fetchInteractionByEmailAndDob(journey_services_1.ProductsEnum.WOLF_MOTOR, this.props.interaction.uistate.relativeInteractionId, this.props.interaction.policyHolder.email, this.props.interaction.policyHolder.dateOfBirth).subscribe(function (previousPolicyInteraction) {
            _this.setState({ previousPolicyInteraction: previousPolicyInteraction });
        });
    };
    AnnualMotorPremiumWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: this.renderOutputPanel() }));
    };
    AnnualMotorPremiumWidget.prototype.renderOutputPanel = function () {
        var interaction = this.props.interaction;
        var factors = interaction.factors;
        var additionalPremiumAmount = factors.debtAmount != null && factors.debtAmount > 0 ? factors.mtaAndDebtCombinedAdditionalAmount : factors.amountToPay;
        var returnPremium = factors.amountToRefund;
        var premiumType = factors.premiumType;
        var paymentRequired = additionalPremiumAmount > 0;
        var refundRequired = returnPremium > 0;
        var price = paymentRequired
            ? (0, commonFunctions_1.getAmountWithDecimalDigits)(additionalPremiumAmount)
            : (0, commonFunctions_1.getAmountWithDecimalDigits)(returnPremium);
        var mtaPremiumWording = AnnualMotorMtaPremiumWordingGenerator_1.AnnualMotorMtaPremiumWordingGenerator.generateMtaPremiumWording(interaction, this.state.previousPolicyInteraction, price);
        var renewalDecline = interaction.uistate.declineRenewal;
        var instalmentsNotPaidOff = factors.premiumType === journey_services_1.PremiumType.monthly && interaction.paymentDetails.instalmentPlan.totalAmount > 0;
        var renewalWindowWording = this.getRenewalPremiumWording();
        if (mtaPremiumWording.isGenericModalBodyWording) {
            window.sessionStorage.setItem("mtaHeadsUpMessageText", mtaPremiumWording.successModalBodyWording);
        }
        else {
            window.sessionStorage.setItem("mtaSuccessMessageText", mtaPremiumWording.successModalBodyWording);
        }
        return ((0, jsx_runtime_1.jsxs)("div", { className: "panel text-center mb-4 policy-change-price", children: [renewalDecline && (0, jsx_runtime_1.jsx)(RenewalDeclineOnMtaBanner_1.RenewalDeclineOnMtaBanner, {}), paymentRequired && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [mtaPremiumWording.premiumWording, interaction.uistate.renewalWindow && (0, jsx_runtime_1.jsx)("div", { children: renewalWindowWording }), (0, jsx_runtime_1.jsx)("p", { children: "All figures include Insurance Premium Tax" })] }), refundRequired && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [mtaPremiumWording.premiumWording, (0, jsx_runtime_1.jsx)("p", { children: this.getRefundWording(premiumType === journey_services_1.PremiumType.monthly, instalmentsNotPaidOff) }), interaction.uistate.renewalWindow && (0, jsx_runtime_1.jsx)("div", { children: renewalWindowWording }), (0, jsx_runtime_1.jsx)("p", { children: "All figures include Insurance Premium Tax" })] }), !refundRequired && !paymentRequired &&
                    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { children: "Great news! There is no extra cost for the change you made!" }), renewalWindowWording && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [renewalWindowWording, (0, jsx_runtime_1.jsx)("p", { className: "text-align-center font-weight-light", children: "All figures include Insurance Premium Tax" })] }))] })] }));
    };
    AnnualMotorPremiumWidget.prototype.getRefundWording = function (isMonthy, instalmentsNotPaidOff) {
        var premiumWording = "";
        if (isMonthy) {
            premiumWording = 'You will receive a pro rata refund for changing your car policy.';
            if (instalmentsNotPaidOff) {
                premiumWording += ' The amount will be deducted from the outstanding balance and spread evenly over the remaining monthly payments.';
            }
        }
        else {
            premiumWording = 'You will receive a pro rata refund for changing your car policy. ' +
                'The refund excludes the cost of your cover prior to the change date.';
        }
        return premiumWording;
    };
    __decorate([
        (0, core_1.lazyInject)(journey_services_1.Types.FalconPropositionEngine),
        __metadata("design:type", Object)
    ], AnnualMotorPremiumWidget.prototype, "propositionEngine", void 0);
    return AnnualMotorPremiumWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualMotorPremiumWidget = AnnualMotorPremiumWidget;
//# sourceMappingURL=AnnualMotorPremiumWidget.js.map